const phone = new RegExp(/^((0)[1-8][0-9]{8}) *$/);
const alpha = new RegExp(/^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*) *$/);
const email = new RegExp(/2^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$/)

export {
    phone,
    alpha,
    email,
}